export const CLEAR_CMSPAGE = 'CLEAR_CMSPAGE';

export default function clearCmsPage() {
  return {
    type: CLEAR_CMSPAGE,
  };
}
